module.exports = __webpack_public_path__ + "img/emoji_19.085be6e9.png";